import sanitizeHtml from 'sanitize-html';
export default {
  nameResolver: val => {
    return val === 'mailsphere' ? 'xift' : val;
  },
  removeUnderScores: val => {
    return val.split('_').join(' ');
  },
  NaNResolver: val => {
    return isNaN(val) ? 0 : val;
  },
  getFormatedAmount: amount => {
    const regex = /[+-]/;
    const currency = amount[0];
    let symbol = '';
    const result = amount.match(regex);
    if (result) {
      symbol = result?.[0];
      const symbolIndex = result?.index;
      return (
        symbol + ' ' + currency + amount.substr(symbolIndex + 1, amount.length)
      );
    }
    return '+ ' + amount;
  },
  sanitize: html =>
    sanitizeHtml(html, {
      allowedTags: sanitizeHtml.defaults.allowedTags.concat([
        'title',
        'img',
        'iframe',
        'p',
        'at',
        'table',
        'tr',
        'td',
        'th'
      ]),
      allowedAttributes: {
        iframe: ['id', 'height', 'width'],
        img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
        a: ['href', 'name', 'target'],
        at: ['name'],
        '*': [
          'style',
          'align',
          'cellpadding',
          'cellspacing',
          'width',
          'id',
          'valign',
          'class'
        ]
      },
      allowedSchemes: ['data', 'http', 'https'],
      transformTags: {
        'at': function() {
          // My own custom html transformations goes here
          return {
            tagName: 'span',
            attribs: {
              class: 'at'
            }
          };
        }
      }
    })
};
